<template>
  <div id="app" style="max-width: 1024px;margin:0 auto;background-color: #f4f4f4">
    <router-view/>
    <Footer v-if="showFooter" style="overflow: hidden"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer/index.vue'
import axios from "axios";

export default {
  name: 'App',
  components:{Footer},
  data(){
    return{
      showFooter:true
    }
  },
  created() {
    localStorage.setItem('libraryName','chemistry')

    //解决微信二次分享问题
    let homeUrl = globalConfig.shareHomeUrl
    if(window.location.href.indexOf('?from=') > -1) {
      history.pushState(null, null, homeUrl);
      location.reload();
    }
  },
  mounted() {
  },
  watch:{
    $route(to,from){
      if(serviceUtil.isBrowserOpen()) {
        // this.$router.push({name:'promptPage'})
        // this.showFooter=false
      } else{
        if(this.$route.name=='promptPag'){
          this.$router.push({name:'home'})
        }
        this.showFooter=true
      }

      //微信分享
      let obj = new FormData()
      obj.append('url', globalConfig.shareParamsUrl)
      axios({
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'post',
        url: globalConfig.basicUrl + '/h5/api/weixin/share/getWxShareInfo',
        data: obj
      }).then(res => {
        shareUtil.wxRegister(res.data.data);
      }).catch(() => {
      });

    }
  }
}
</script>

<style>
#app {
  font-family: PingFangSC-Medium, PingFang SC, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue